import { CatalogueListLayout } from '@/components/common/CatalogueListLayout';
import { DataTable } from '@/components/common/DataTable';
import { ErrorState } from '@/components/common/ErrorState';
import { useInfiniteTableQuery } from '@/hooks/useInfiniteTableQuery';
import { promoAssignmentsInfiniteQueryOptions } from '../api/promotion.api';
import { getAssignmentColumns } from '../components/PromoColumns';
import { usePromoCatalogueFilters } from '../hooks/usePromoCatalogueFilters';
import { getUserPromoStatCards } from '../utils/promotionStatCards';

export function PromoDistributionPage() {
  const controller = usePromoCatalogueFilters('assignments');
  const { rows, firstPageMeta, isLoading, isRefetching, loadError, refetch, loadMoreProps } =
    useInfiniteTableQuery(promoAssignmentsInfiniteQueryOptions(controller.params));

  return (
    <CatalogueListLayout
      title="Promotional Item Distribution"
      search={{
        value: controller.searchText,
        onChange: controller.setSearchText,
        placeholder: 'Search by name or HR id',
      }}
      filters={controller}
      stats={{
        cards: getUserPromoStatCards(firstPageMeta),
        isLoading,
        isFetching: isRefetching,
        isError: loadError !== null,
      }}
    >
      {loadError ? (
        <ErrorState
          error={loadError}
          fallbackTitle="Could not load the assignments"
          onRetry={() => void refetch()}
          fill
        />
      ) : (
        <DataTable
          data={rows}
          columns={getAssignmentColumns()}
          isLoading={isLoading}
          className="lg:flex-1"
          stickyColumnId="name"
          emptyMessage="Nothing has been assigned"
          {...loadMoreProps}
        />
      )}
    </CatalogueListLayout>
  );
}
